import SliderComponent from "slotworks/components/ui/slider-component";
import FlexiSlider from "slotworks/graphics/elements/flexi-slider";
import FlexiText from "slotworks/graphics/elements/flexi-text";
import SliderElement from "slotworks/graphics/elements/slider-element";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractSliderControl extends AbstractControl implements Control {

    protected sliderComponent: SliderComponent;
    protected value: number;

    protected minLabel: FlexiText;
    protected maxLabel: FlexiText;
    protected valueLabel: FlexiText;

    protected formatFunction: (value: number) => string;

    private data: number[];

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        const track = this.layer.getSprite(assetName + "_track");
        const fill = this.layer.getSprite(assetName + "_fill");
        const handle = this.layer.getSprite(assetName + "_handle");

        this.minLabel = this.layer.getFlexiText(assetName + "_min_label");
        this.maxLabel = this.layer.getFlexiText(assetName + "_max_label");
        this.valueLabel = this.layer.getFlexiText(assetName + "_label");

        let flexiSlider = this.layer.getFlexiSlider(assetName);
        if (!flexiSlider) {
            flexiSlider = new FlexiSlider();
        }
        if (track && fill && handle) {
            const sliderElement = new SliderElement(track, fill, handle);
            flexiSlider.addTarget(sliderElement);
        }

        this.sliderComponent = new SliderComponent(flexiSlider);
        this.sliderComponent.onInput.add(this.onInputHandler);
    }

    public setupData(array: number[], currentValue: number) {
        this.data = array;

        this.setValueLabel(currentValue);
        this.setupLabels(array[0], array[array.length - 1]);
        this.setupSlider(0, array.length - 1, 1);
        this.setSliderIndex(array.indexOf(currentValue));
    }

    public setupLabels(min: number, max: number) {
        if (this.minLabel) {
            this.minLabel.setText(this.formatFunction(min));
        }
        if (this.maxLabel) {
            this.maxLabel.setText(this.formatFunction(max));
        }
    }

    public setValueLabel(text: number) {
        if (this.valueLabel) {
            this.valueLabel.setText(this.formatFunction(text));
        }
    }

    public setSliderIndex(index: number) {
        this.sliderComponent.setValue(index);
    }

    public destroy() {
        this.sliderComponent.destroy();
    }

    public setVisible(visible: boolean) {
        this.sliderComponent.setVisible(visible);
    }

    public setEnabled(enabled: boolean) {
        if (this.sliderComponent) {
            this.sliderComponent.setEnabled(enabled);
        }
    }

    private onInputHandler = (value: number) => {
        this.setValueLabel(this.data[value]);
    }

    private setupSlider(min: number, max: number, step: number) {
        this.sliderComponent.setup(min, max, step);
    }
}
